import { Constants } from '@hvf/contracts'
import type { Component } from 'solid-js'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { FilterSelect } from './FilterSelect'

export const Stage: Component = () => {
  const { filters, setStage } = useService(useFilters)()

  return (
    <FilterSelect
      label="Stage"
      items={Constants.public.Enums.stage}
      selected={filters().stage}
      onChange={setStage}
    />
  )
}
